import { Container, Grid, Typography, makeStyles } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React from 'react';
import InputBuscadorPaginadoWithFormik from '../../../components/InputBuscadorPaginadoWithFormik';
import ListDataProvider from '../../../toolkit/mobx-connectors/ListDataProvider';
import axios from '../../../utils/axios';
import Filter from '../../../utils/filter';
import createParams from '../../../utils/tables-params';
import importadorConfig from './ImportadorConfig';

const useStyles = makeStyles(theme => ({
  innerContainer: {
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  }
}));

const ImportadorForm = props => {
  const { gridProps, enqueueSnackbar } = props;
  const formik = useFormikContext();
  const classes = useStyles();

  const configuraciones = importadorConfig({
    classes: {}
  });
  const dataset = 'importador';

  const { datosConfig } = configuraciones[dataset];
  const { datosSettings } = configuraciones[dataset];

  const onReloadTable = () => {
    const settings = datosSettings;
    const params = createParams({ ...props.importadoresForm.list, settings });

    if (params.filter) {
      params.filter.and(Filter.path('activado').eq(1));
      params.filter = JSON.stringify(params.filter);
    } else {
      params.filter = JSON.stringify(Filter.path('activado').eq(1));
    }

    axios
      .get(datosConfig.servicio, {
        data: {},
        params
      })
      .then(resp => {
        return props.importadoresForm.list.dataLoaded(resp.data.data, {
          currentPage: resp.data.meta.currentPage - 1,
          pageSize: resp.data.meta.pageSize,
          itemsCount: resp.data.meta.total
        });
      })
      .catch(() => {
        enqueueSnackbar('Error al obtener los datos', 'error');
      });
  };

  return (
    <Container maxWidth="sm" className={classes.innerContainer}>
      <Grid container item>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Formulario para carga de datos del Importador
        </Typography>
      </Grid>
      <Grid container {...gridProps}>
        <Grid item xs={12} md={12}>
          <ListDataProvider
            listStore={props.importadoresForm.list}
            render={listProps => (
              <InputBuscadorPaginadoWithFormik
                required
                label="Importador"
                name="importador"
                labelKey="nombre"
                valueKey="id"
                placeholder="Seleccione..."
                list={listProps}
                datosConfig={datosConfig}
                datosSettings={datosSettings}
                onReloadTable={onReloadTable}
                onSelected={(_, item) => {
                  formik.setFieldValue('importador', item);
                }}
              />
            )}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default inject('importadoresForm')(
  observer(withSnackbar(ImportadorForm))
);
